import style from './style.scss';

/**
 * Card component to display a stylised card. The content of the card should be passed in
 * as children.
 *
 * props:
 * - cardTitle: the title displayed at the top of the card
 * - enlargeTitle: whether or not the title should be enlarged compared to normal (true or false)
 * - noMargin: set to true to remove card bottom margin
 */

const Card = props => {

	const cssClasses = [style.card];

	if (props.noMargin) {
		cssClasses.push(style.no_margin);
	}

	return (
		<div class={cssClasses.join(' ')}>
			{
				props.cardTitle
					? <h3 class={props.enlargeTitle ? style.card_title_large : style.card_title}>{ props.cardTitle }</h3>
					: null
			}
			{ props.children }
		</div>
	)

};

export default Card;



// WEBPACK FOOTER //
// ./components/card/index.js